import { useMemo } from 'react';

import { buildApiReportData } from '../builders/buildApiReportData.ts';
import { buildPdfReportData } from '../builders/buildPdfReportData.ts';
import { AppraisifyReport } from '../types.ts';
import { useAppraisalReportData } from './useAppraisalReportData.tsx';

/**
 * Hook that returns both PDF and API export data.
 * Use this hook when you need to export the report in both formats, to avoid redundant data processing.
 */
export const useAppraisifyReport = (): AppraisifyReport => {
  const coreData = useAppraisalReportData();

  return useMemo(
    () => ({
      pdfData: buildPdfReportData(coreData),
      appraisalData: buildApiReportData(coreData),
    }),
    [coreData],
  );
};
